import { memo, useContext } from "react";
import PropTypes from "prop-types";
import OffersOverview from "app/pages/.shared/OffersOverview/OffersOverview";
import DealTimer from "app/pages/.shared/Deal/DealTimer/DealTimer";
import { FormattedMessage } from "react-intl";
import Button from "app/pages/.shared/form/Button";
import "./AsideOffersOverview.scss";
import PaymentDescriptionTermsContainer from "app/pages/Booking/Payment/PaymentDescriptionTerms/PaymentDescriptionTermsContainer";
import DepositDescriptionTermsContainer from "app/pages/Booking/Payment/PaymentDescriptionTerms/DepositDescriptionTermsContainer";
import AppGlobalsContext from "app/AppGlobalsContext";

const AsideOffersOverview = ({ offers, hour, day, onClick, itemClickable = true }) => {
	const offerCount = offers.length;
	const { shop } = useContext(AppGlobalsContext);

	return (
		<div className="aside-offers-overview">
			<div className="aside-offers-overview__timer">
				<DealTimer hour={hour} day={day} />
			</div>

			<div className="aside-offers-overview__offers">
				<OffersOverview offers={offers} clickable={itemClickable} />
				{shop === "en-GB" ? (
					<DepositDescriptionTermsContainer />
				) : (
					<PaymentDescriptionTermsContainer />
				)}
			</div>
			<div className="aside-offers-overview__cta">
				<Button variant="primary" onClick={onClick}>
					{offerCount > 1 ? (
						<FormattedMessage id="product.page.aside.cta.label" />
					) : (
						<FormattedMessage id="product.page.aside.cta.label.single.offer" />
					)}
				</Button>
			</div>
		</div>
	);
};

AsideOffersOverview.propTypes = {
	offers: PropTypes.array,
	hour: PropTypes.number,
	day: PropTypes.number,
	onClick: PropTypes.func,
	itemClickable: PropTypes.bool,
};

AsideOffersOverview.defaultProps = {
	offers: [],
};

export default memo(AsideOffersOverview);
